/* eslint-disable no-unused-vars */
import React, { useContext } from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';

import { AuthContext } from '../contexts/AuthProvider';

import Home from '../pages/Home';
import Flights from '../pages/Flights';
import Weddings from '../pages/Weddings';
import Circuits from '../pages/Circuits';
import Flyers from '../pages/Flyers';
import Cruisers from '../pages/Cruisers';
import TowerTravel from '../pages/TowerTravel';
import AirlineCompanies from '../pages/AirlineCompanies';
import NotFound from '../pages/NotFound';

const Routes = (props) => {
  const { user } = useContext(AuthContext);

  return (
    <Switch>
      <Route exact path='/bodas' component={Weddings} />
      <Route exact path='/circuitos' component={Circuits} />
      <Route exact path='/flyers' component={Flyers} />
      {/* Cruceros podria ser una private route, interno pero con auth de witwan */}
      <Route exact path='/cruceros' component={Cruisers} />
      <Route exact path='/tower-travel' component={TowerTravel} />
      <Route exact path='/companias-aereas' component={AirlineCompanies} />

      <Route exact path='/' component={Home} />

      <Route path='*'>
        <Redirect to='/' />
        {/* <NotFound /> */}
      </Route>
    </Switch>
  );
};

export default Routes;
